<p-stepper [(value)]="currentStep" class="w-full">

    <p-step-list>

        <!-- Étape 1 : Nom de l'appareil -->
        <p-step [value]="1">
            <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <p-button icon="pi pi-mobile" [severity]="value <= currentStep ? 'primary' : 'secondary'"
                    [rounded]="true" (click)="activateCallback(1)" />
            </ng-template>
        </p-step>

        <!-- Étape 2 : QR Code -->
        <p-step [value]="2">
            <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <p-button icon="pi pi-qrcode" [severity]="value <= currentStep ? 'primary' : 'secondary'"
                    [rounded]="true" [disabled]="!qrCodeDataUrl" (click)="activateCallback(2)" />
            </ng-template>
        </p-step>

        <!-- Étape 3 : Confirmation du code -->
        <p-step [value]="3">
            <ng-template #content let-activateCallback="activateCallback" let-value="value">
                <p-button icon="pi pi-shield" [severity]="value <= currentStep ? 'primary' : 'secondary'"
                    [rounded]="true" [disabled]="!qrCodeDataUrl" (click)="activateCallback(3)" />
            </ng-template>
        </p-step>
    </p-step-list>

    <p-step-panels>
        @switch (currentStep) {

        <!-- Étape 1 : Nom de l'appareil -->
        @case (1) {
        <div class="flex align-items-center gap-1 mb-2">
            <span class="text-xl font-medium">Configurer la double authentification</span>
            <app-mfa-info [visible]="!!preAuthToken && !manageMode" [loginContext]="!!preAuthToken && !manageMode"></app-mfa-info>
        </div>
        <p class="text-color-secondary text-sm mb-4">
            Donnez un nom à cet appareil pour l'identifier facilement.
        </p>
        <form [formGroup]="form" (ngSubmit)="setupDevice()" novalidate class="flex flex-column gap-4">
            <input pInputText formControlName="deviceName" placeholder="Ex: Mon téléphone" class="w-full" />
            <p-button type="submit" label="Continuer" icon="pi pi-arrow-right" iconPos="right" styleClass="w-full"
                [pAutoFocus]="true" [rounded]="true" [disabled]="form.get('deviceName')!.invalid" [loading]="loading">
            </p-button>
        </form>
        }

        <!-- Étape 2 : QR Code -->
        @case (2) {
        <div class="text-xl font-medium mb-2">Scanner le QR code</div>
        <p class="text-color-secondary text-sm mb-3">
            Scannez ce QR code avec votre application d'authentification
            (Google Authenticator, Authy, etc.).
        </p>
        <div class="flex flex-column align-items-center gap-3">
            @if (qrCodeDataUrl) {
            <img [src]="qrCodeDataUrl" alt="QR Code MFA" style="width: 200px; height: 200px;" />
            }
            <button type="button"
                class="p-button-link text-sm text-color-secondary border-none bg-transparent cursor-pointer"
                (click)="showSecret = !showSecret">
                {{ showSecret ? 'Masquer le code manuel' : 'Saisie manuelle impossible ?' }}
            </button>
            @if (showSecret) {
            <div class="surface-100 border-round p-2 text-sm font-mono text-center w-full">
                {{ secret }}
            </div>
            }
        </div>
        <p-button label="J'ai scanné le QR code" icon="pi pi-arrow-right" iconPos="right" styleClass="w-full mt-4"
            [rounded]="true" (onClick)="currentStep = 3">
        </p-button>
        }

        <!-- Étape 3 : Confirmation du code -->
        @case (3) {
        <div class="text-xl font-medium mb-2">Confirmer l'activation</div>
        <p class="text-color-secondary text-sm mb-4">
            Saisissez le code à 6 chiffres affiché dans votre application pour confirmer.
        </p>
        <div class="flex align-items-center justify-content-center">
            <form [formGroup]="form" novalidate class="flex flex-column gap-4 w-17rem">
                <div class="flex justify-content-center">
                    <p-inputotp formControlName="code" [pAutoFocus]="true" [length]="6" [integerOnly]="true"></p-inputotp>
                </div>
            </form>
        </div>
        }

        }
    </p-step-panels>

</p-stepper>